import { useQuery } from '@tanstack/react-query'
import { listStorefrontCatalog } from '../api/products'
import type { ApiStorefrontCatalog } from '../api/types'
import { QUERY_KEYS } from '../constants/query'
import type { DeliveryLocation } from '../constants/location'
import { toApiMessage } from '../helpers/api-error'
import { useDeliveryLocation } from './useDeliveryLocation'

export function storefrontCoordinates(location: DeliveryLocation | null): {
  latitude: number
  longitude: number
} | null {
  if (typeof location?.lat !== 'number' || typeof location.lng !== 'number') {
    return null
  }
  return { latitude: location.lat, longitude: location.lng }
}

type StorefrontCatalogState = {
  catalog: ApiStorefrontCatalog | null
  hasLocation: boolean
  loading: boolean
  error: string | null
}

export function useStorefrontCatalog(): StorefrontCatalogState {
  const { location } = useDeliveryLocation()
  const coords = storefrontCoordinates(location)
  const catalogQuery = useQuery({
    queryKey: QUERY_KEYS.storefront(coords?.latitude ?? null, coords?.longitude ?? null),
    queryFn: () => listStorefrontCatalog(coords ?? undefined),
  })
  const error = catalogQuery.error
    ? toApiMessage(catalogQuery.error, 'Failed to load products')
    : null

  return {
    catalog: catalogQuery.data ?? null,
    hasLocation: coords !== null,
    loading: catalogQuery.isPending && !catalogQuery.data && !error,
    error,
  }
}
